export default __webpack_public_path__ + "static/media/mailgun-dark.4c9b9a4d.png";